import axiosInstance from "../utils/axios";

export const getStudentDetails = async (values) => {
  return await axiosInstance().get("/getStudentDetails", { params: values });
};

export const viewStudent = async (values) => {
  return await axiosInstance().get("/viewStudent", { params: values });
};

export const SaveSettings = async (values) => {
  return await axiosInstance().post("/settings/", values);
};

export const GetAuditTrails = async () => {
  return await axiosInstance().post("/getServerTimeAuditTrail");
}